<div
	class="panel panel-primary"
	[class.panel-closed]="isCollapsed()" [class.panel-opened]="!isCollapsed()"
	[class.panel-enabled]="!isDisabled()" [class.panel-disabled]="isDisabled()"
>
	@if (!hideHeading()) {
		<div class="panel-heading" (click)="expandCollapse($event)">
			<div class="hmf-display-flex hmf-align-items-center" [class.hmf-justify-content-center]="isTitleCentered()">
				<ng-content select="[myPanelHeader]"></ng-content>
				@if (!isDisabled()) {
					<button class="button-accordion-toggle header-icon hmf-display-flex hmf-justify-content-center hmf-align-items-center hmf-ml-xxs" [class.small-icon]="arrowIconSmall()" [class.arrow-up]="!isCollapsed()" [class.hmf-display-none]="hideArrowIcon()" [attr.aria-label]="altText()">
						<homefield-icon class="chevron-up" width="24px" height="24px" name="chevron-down-outline" [attr.title]="altText()"></homefield-icon>
					</button>
				}
			</div>
			@if (!hideHeaderLine()) {
				<hr [class.hmf-display-none]="hideMobileHeaderLine()" [class.hmf-display-m-block]="hideMobileHeaderLine()">
			}
		</div>
	}
	<div class="panel-heading-secondary">
		<ng-content select="[myPanelHeaderSecondary]"></ng-content>
	</div>
	<div class="panel-collapse-container">
		<div class="panel-body" [@openClose]="isCollapsed() ? 'closed' : 'open'">
			@if (!hideBodyAndFooter()) {
				<ng-content select="[myPanelBody]"></ng-content>
			}
		</div>
		<div class="panel-footer" [@openClose]="isCollapsed() ? 'closed' : 'open'">
			@if (!hideBodyAndFooter()) {
				<ng-content select="[myPanelFooter]"></ng-content>
			}
		</div>
	</div>
</div>